exports.install = function (Vue, options) {
	//登录
	Vue.prototype.login = function(value)
	{
		return this.axiospost("/api/user/login",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.setCookie(this.config.token,response.data.data.userinfo.token,3);
				// this.setCookie(this.config.logout,'',3);
				this.loginto(response.data.data.userinfo);
				this.$store.commit('user',response.data.data.userinfo);
			}
			return response;
		});
	};
	//获取用户信息
	Vue.prototype.getuser = function()
	{
		return this.axiosget("/api/user/index")
		.then((response)=>{
			if(response.data.code==1)
			{
				this.loginto(response.data.data);
				this.$store.commit('user',response.data.data);
			}
			return response;
		});
	};
	//注册
	Vue.prototype.register = function(value)
	{
		return this.axiospost("/api/user/register",value)
		.then((response)=>{
			return response;
		});
	};
	//登出
	Vue.prototype.logout = function()
	{
		return this.axiosget("/api/user/logout");
	};
	//修改个人信息
	Vue.prototype.edituser = function(value)
	{
		return this.axiospost("/api/user/profile",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				this.getuser();
			}
			return response;
		});
	};
	//修改密码
	Vue.prototype.editpass = function(value)
	{
		this.axiospost("/api/user/resetpwd",value);
	};
}